<section class="landing-hub" *ngIf="!isDashboardView">
  <div class="landing-hub-header">
    <h1 *ngIf="currentLandingStage === 'refinery'">Select Refinery</h1>
    <h1 *ngIf="currentLandingStage === 'unit'">Select Unit</h1>
    <p *ngIf="currentLandingStage === 'refinery'">Select a refinery to continue.</p>
    <p *ngIf="currentLandingStage === 'unit'">Select a unit under {{ selectedRefineryCard?.label }} to continue.</p>
  </div>

  <div class="landing-card-grid" *ngIf="currentLandingStage === 'refinery'">
    <button
      type="button"
      class="landing-card"
      *ngFor="let refinery of refineryLandingCards"
      (click)="onRefineryCardClick(refinery)">
      <img [src]="refinery.imageUrl" [alt]="refinery.label + ' refinery'" title="Refinery image" />
      <span>{{ refinery.label }}</span>
    </button>
  </div>

  <div class="landing-run-state" *ngIf="currentLandingStage === 'refinery' && isLandingCardsLoading">Loading refineries...</div>
  <div class="landing-run-state error" *ngIf="currentLandingStage === 'refinery' && !isLandingCardsLoading && hasLandingCardsLoadError">Unable to load refinery list.</div>
  <div class="landing-run-state" *ngIf="currentLandingStage === 'refinery' && !isLandingCardsLoading && !hasLandingCardsLoadError && refineryLandingCards.length === 0">No refineries available.</div>

  <div class="landing-card-grid" *ngIf="currentLandingStage === 'unit' && selectedRefineryCard">
    <button
      type="button"
      class="landing-card"
      *ngFor="let unit of selectedRefineryCard.units"
      (click)="onUnitCardClick(unit)">
      <img [src]="unit.imageUrl" [alt]="unit.label + ' unit'" title="Unit image" />
      <span>{{ unit.label }}</span>
    </button>
  </div>

</section>

<ng-container *ngIf="isDashboardView">
<section class="home-dashboard">
  <div class="report-summary">
    <div class="summary-main">
      <p class="prepared-for">Report prepared for : {{ reportPreparedFor }}</p>
      <h1 class="report-title">{{ reportTitle }}</h1>
      <p class="reporting-period">{{ reportingPeriodLabel }} {{ reportingPeriodValue }}</p>
      <p class="reporting-period-disclaimer">All dates shown in MM-DD-YYYY format.</p>
    </div>

    <div class="summary-run-select">
      <p class="run-summary-last-updated" *ngIf="selectedRun">
        Last updated: {{ runSummaryLastUpdatedLabel }}
      </p>
      <div class="summary-run-controls">
      <button
        *ngIf="runSummaryRegenerationRequired"
        type="button"
        class="regenerate-btn"
        (click)="onRegenerateClick()"
        [disabled]="isPdfRegenerating"
        title="Regenerate report with saved edits"
        aria-label="Regenerate report with saved edits">
        <span class="material-icons-outlined" aria-hidden="true">refresh</span>
      </button>
      <button
        *ngIf="selectedRun"
        type="button"
        class="download-report-btn"
        (click)="onDownloadReportClick()"
        [disabled]="isPdfDownloading || isPdfRegenerationInProgress"
        title="Download report for selected month"
        aria-label="Download report for selected month">
        <span class="material-icons-outlined">{{ isPdfDownloading ? 'hourglass_empty' : 'download' }}</span>
      </button>
      <select
        id="runSelect"
        [(ngModel)]="selectedRun"
        (ngModelChange)="onRunSelectionChange($event)"
        [disabled]="isRunOptionsLoading"
        aria-label="Select Run">
        <option value="" disabled>{{ isRunOptionsLoading ? 'Loading...' : 'Select Month' }}</option>
        <option *ngFor="let run of runOptions" [value]="run.runId">{{ run.label }}</option>
      </select>
      </div>
    </div>
  </div>

  <div class="run-summary-loading" *ngIf="isRunSummaryLoading" role="status" aria-live="polite">
    <span class="loading-dot" aria-hidden="true"></span>
    Loading selected run data...
  </div>

  <div class="metrics-grid">
    <article
      class="metric-card"
      *ngFor="let card of metricCards"
      [class.metric-card-clickable]="isMetricCardClickable(card)"
      [class.metric-card-active]="isMetricCardActive(card)"
      [attr.role]="isMetricCardClickable(card) ? 'button' : null"
      [attr.tabindex]="isMetricCardClickable(card) ? '0' : null"
      [attr.aria-pressed]="isMetricCardClickable(card) ? isMetricCardActive(card) : null"
      (click)="onMetricCardClick(card)"
      (keydown)="onMetricCardKeydown($event, card)">
      <div class="card-title">
        <span>{{ card.title }}</span>
        <button
          *ngIf="hasMetricCardTooltip(card)"
          type="button"
          class="metric-card-info-btn"
          [attr.aria-label]="'More information for ' + card.title"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          <span class="material-icons-outlined" aria-hidden="true">info</span>
          <span class="metric-card-tooltip" role="tooltip">{{ card.tooltip }}</span>
        </button>
      </div>
      <div class="card-value">{{ card.value }}</div>
    </article>
  </div>
</section>

</ng-container>

<section class="risk-register-section" *ngIf="isDashboardView">
  <div class="risk-register-toggle" [attr.aria-expanded]="isRiskRegisterExpanded">
    <div class="risk-register-title-wrap">
      <span class="risk-register-title">{{ riskRegisterTitle }}</span>
      <span class="risk-register-total" *ngIf="selectedRun && !isRunAssetsLoading">Total results: {{ riskRegisterVisibleResultsCount }}</span>
      <span class="risk-register-total" *ngIf="isRunAssetsLoading">Loading table results...</span>
    </div>
    <div class="risk-register-controls">
      <div class="risk-register-search">
        <span class="material-icons-outlined search-icon" aria-hidden="true">search</span>
        <input
          type="text"
          [ngModel]="riskRegisterSearchQuery"
          (ngModelChange)="onRiskRegisterSearchChange($event)"
          placeholder="Search by Asset Tag or Description"
          aria-label="Search by asset tag or asset description" />
      </div>

      <button
        type="button"
        class="risk-register-filter-btn"
        (click)="openFilterDialog()"
        aria-label="Filter ranked risk register">
        <span class="material-icons-outlined filter-icon" aria-hidden="true">filter_alt</span>
      </button>

      <button
        type="button"
        class="clear-filter-btn"
        *ngIf="hasAppliedFilters"
        (click)="clearAppliedFilters()"
        aria-label="Clear all applied filters">
        Clear Filters
      </button>

      <button
        type="button"
        class="risk-register-collapse-btn"
        (click)="toggleRiskRegister()"
        [attr.aria-expanded]="isRiskRegisterExpanded"
        aria-label="Toggle ranked risk register table">
        <span class="material-icons-outlined accordion-icon" [class.expanded]="isRiskRegisterExpanded">expand_more</span>
      </button>
    </div>
  </div>

  <div
    class="risk-register-table-wrap"
    *ngIf="isRiskRegisterExpanded"
    [style.max-height]="riskRegisterTableMaxHeight">
    <table class="risk-register-table" aria-label="Ranked risk register" *ngIf="paginatedRiskRegisterRows.length > 0; else riskRegisterEmptyState">
      <thead>
        <tr>
          <th class="row-expand-column"></th>
          <th *ngFor="let column of riskRegisterColumns" [class.group-divider]="column.dividerAfter">
            <ng-container *ngIf="!column.sortable; else sortableHeader">{{ column.label }}</ng-container>

            <ng-template #sortableHeader>
              <div class="sortable-header">
                <span class="sortable-header-label">{{ column.label }}</span>
                <span class="sortable-header-controls">
                  <button
                    type="button"
                    class="sort-btn"
                    [class.active]="isRiskRegisterSortActive($any(column.key), 'asc')"
                    [attr.aria-pressed]="isRiskRegisterSortActive($any(column.key), 'asc')"
                    [attr.aria-label]="'Sort ' + column.label + ' ascending'"
                    title="Sort ascending"
                    (click)="onRiskRegisterSortChange($any(column.key), 'asc')">
                    <span class="material-icons-outlined" aria-hidden="true">arrow_drop_up</span>
                  </button>
                  <button
                    type="button"
                    class="sort-btn"
                    [class.active]="isRiskRegisterSortActive($any(column.key), 'desc')"
                    [attr.aria-pressed]="isRiskRegisterSortActive($any(column.key), 'desc')"
                    [attr.aria-label]="'Sort ' + column.label + ' descending'"
                    title="Sort descending"
                    (click)="onRiskRegisterSortChange($any(column.key), 'desc')">
                    <span class="material-icons-outlined" aria-hidden="true">arrow_drop_down</span>
                  </button>
                </span>
              </div>
            </ng-template>
          </th>
          <th class="action-column" *ngIf="canViewRiskRegisterActions">Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of paginatedRiskRegisterRows">
          <tr>
            <td class="row-expand-column">
              <button
                type="button"
                class="row-expand-btn"
                [attr.aria-label]="row.isExpanded ? 'Collapse row' : 'Expand row'"
                [attr.aria-expanded]="row.isExpanded"
                (click)="toggleRow(row)">
                <span class="material-icons-outlined">{{ row.isExpanded ? 'expand_more' : 'chevron_right' }}</span>
              </button>
            </td>
            <td *ngFor="let column of riskRegisterColumns" [class.group-divider]="column.dividerAfter" [ngClass]="getCellClass(column.key)">
              <ng-container [ngSwitch]="column.key">
                <!-- Rank Column with colored badges -->
                <div *ngSwitchCase="'rank'" class="rank-cell">
                  <div class="rank-badge" [ngClass]="getRankBadgeClass(row.band)">
                    {{ row.rank }}
                  </div>
                </div>
                
                <!-- Score Column with progress bar -->
                <div *ngSwitchCase="'score'" class="score-cell">
                  <div class="score-container">
                    <div class="score-value" [attr.title]="getScoreFactorsTooltipLabel(row)">{{ row.score }}</div>
                    <div class="score-bar-track">
                      <div class="score-bar-fill" [style.width.%]="getScorePercentage(row.score)"></div>
                    </div>
                  </div>
                </div>

                <div *ngSwitchCase="'aiAdjustedRiskScore'" class="ai-adjusted-score-cell">
                  <span>{{ row.aiAdjustedRiskScore }}</span>
                </div>

                <div *ngSwitchCase="'risk_trend'">
                  {{ row.risk_trend | uppercase }}
                </div>
                
                <!-- Default for all other columns -->
                <ng-container *ngSwitchDefault>{{ row[column.key] }}</ng-container>
              </ng-container>
            </td>
            <td class="action-column" *ngIf="canViewRiskRegisterActions">
              <div class="row-action-group">
                <button
                  type="button"
                  class="row-action-btn"
                  (click)="onEditRow(row)"
                  aria-label="Edit row">
                  <span class="material-icons-outlined">edit</span>
                </button>
                <span class="row-action-delete-wrap" [attr.title]="row.isDeleted ? 'Already deleted' : null">
                  <button
                    type="button"
                    class="row-action-btn row-action-delete-btn"
                    (click)="onDeleteRow(row)"
                    [disabled]="row.isDeleted"
                    [attr.aria-label]="row.isDeleted ? 'Already deleted' : 'Delete row'">
                    <span class="material-icons-outlined">delete</span>
                  </button>
                </span>
              </div>
            </td>
          </tr>

          <tr class="risk-detail-row" *ngIf="row.isExpanded">
            <td [attr.colspan]="riskRegisterColumns.length + (canViewRiskRegisterActions ? 2 : 1)" class="risk-detail-cell">
              <div class="risk-detail-panel">
                <ng-container *ngIf="!isRiskDetailLoading(row); else riskDetailLoadingTemplate">
                <div class="risk-detail-header">
                  <div class="risk-detail-title-group">
                    <span class="risk-detail-title-asset">{{ getRiskDetailTopSummary(row).assetTag }}</span>
                    <span class="risk-detail-title-sep">|</span>
                    <span class="risk-detail-title-type">{{ getRiskDetailTopSummary(row).riskType }}</span>
                    <span class="risk-detail-title-sep">|</span>
                    <span class="risk-detail-title-criticality">CRITICALITY: {{ getRiskDetailTopSummary(row).criticality }}</span>
                    <button type="button" class="risk-detail-citations-btn" (click)="onCitationsClick(row)">Citations</button>
                  </div>
                  <span class="risk-detail-score">Score: {{ getRiskDetailTopSummary(row).score }}</span>
                </div>

                <ul class="risk-detail-summary-points" *ngIf="getRiskDetailNarrativePoints(row).length > 0; else riskDetailSummaryFallback">
                  <li *ngFor="let point of getRiskDetailNarrativePoints(row)">{{ point }}</li>
                </ul>
                <ng-template #riskDetailSummaryFallback>
                  <p class="risk-detail-summary">No narrative summary available for this asset.</p>
                </ng-template>

                <div class="risk-detail-callout warning">
                  <div class="risk-detail-callout-title">
                    MAIN CONCERN
                    <button type="button" class="risk-detail-info-icon" 
                            (click)="toggleRiskDetailTooltip(row, 'mainConcern')"
                            [attr.aria-expanded]="isRiskDetailTooltipOpen(row, 'mainConcern')"
                            aria-label="Show AI reasoning for main concern">
                      <span class="material-icons-outlined">info</span>
                    </button>
                  </div>
                  <div class="risk-detail-tooltip" *ngIf="isRiskDetailTooltipOpen(row, 'mainConcern')">
                    {{ getRiskDetailMainConcernReasoning(row) }}
                  </div>
                  <div class="risk-detail-callout-body">{{ getRiskDetailMainConcern(row) }}</div>
                </div>

                <div class="risk-detail-callout success">
                  <div class="risk-detail-callout-title">
                    Recommended Action
                    <button type="button" class="risk-detail-info-icon" 
                            (click)="toggleRiskDetailTooltip(row, 'recommendedAction')"
                            [attr.aria-expanded]="isRiskDetailTooltipOpen(row, 'recommendedAction')"
                            aria-label="Show AI reasoning for recommended action">
                      <span class="material-icons-outlined">info</span>
                    </button>
                  </div>
                  <div class="risk-detail-tooltip" *ngIf="isRiskDetailTooltipOpen(row, 'recommendedAction')">
                    {{ getRiskDetailRecommendedActionReasoning(row) }}
                  </div>
                  <div class="risk-detail-callout-body">{{ getRiskDetailRecommendedAction(row) }}</div>
                </div>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'chronologicalWalkthrough')"
                    (click)="toggleRiskDetailSection(row, 'chronologicalWalkthrough')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'chronologicalWalkthrough') ? 'expand_more' : 'chevron_right' }}</span>
                    Trend of Selected Month
                  </button>
                  <div class="risk-detail-subsection-body" *ngIf="isRiskDetailSectionExpanded(row, 'chronologicalWalkthrough')">
                    <ul class="risk-detail-bullet-list" *ngIf="getRiskDetailChronologicalPoints(row).length > 0; else riskDetailChronologyFallback">
                      <li *ngFor="let point of getRiskDetailChronologicalPoints(row)">{{ point }}</li>
                    </ul>
                    <ng-template #riskDetailChronologyFallback>
                      No chronological walkthrough data available.
                    </ng-template>
                  </div>
                </section>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'trendAnalysis')"
                    (click)="toggleRiskDetailSection(row, 'trendAnalysis')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'trendAnalysis') ? 'expand_more' : 'chevron_right' }}</span>
                    Trend of Last 6 Months
                  </button>
                  <div class="risk-detail-subsection-body muted" *ngIf="isRiskDetailSectionExpanded(row, 'trendAnalysis')">
                    <div class="risk-detail-trend-timeline" *ngIf="getRiskDetailTrendTimeline(row).length > 0; else riskDetailTrendFallback">
                      <div class="risk-detail-trend-strip">
                        <div class="risk-detail-trend-strip-scroll">
                          <ol class="risk-detail-trend-dots-row">
                            <li class="risk-detail-trend-dot-node" *ngFor="let point of getRiskDetailTrendTimeline(row); let index = index">
                              <button
                                type="button"
                                class="risk-detail-trend-dot"
                                [class.active]="getRiskDetailActiveTrendIndex(row) === index"
                                [attr.aria-label]="'Open trend point for ' + point.date"
                                [title]="point.date"
                                (click)="onRiskDetailTrendDotClick(row, index)">
                                Open trend point {{ index + 1 }}
                              </button>
                              <span class="risk-detail-trend-date">{{ point.date }}</span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div class="risk-detail-trend-content-card" *ngIf="getRiskDetailActiveTrendPoint(row) as activePoint">
                        {{ activePoint.content }}
                      </div>
                    </div>
                    <ng-template #riskDetailTrendFallback>
                      No trend analysis data available.
                    </ng-template>
                  </div>
                </section>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'preventiveMaintenance')"
                    (click)="toggleRiskDetailSection(row, 'preventiveMaintenance')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'preventiveMaintenance') ? 'expand_more' : 'chevron_right' }}</span>
                    Preventive Maintenance Work Orders (last 6 months)
                  </button>
                  <div class="risk-detail-subsection-body neutral" *ngIf="isRiskDetailSectionExpanded(row, 'preventiveMaintenance')">
                    <ul class="risk-detail-bullet-list" *ngIf="getRiskDetailPmMentions(row).length > 0; else riskDetailPmFallback">
                      <li *ngFor="let pm of getRiskDetailPmMentions(row)">{{ pm }}</li>
                    </ul>
                    <ng-template #riskDetailPmFallback>
                      No PM work orders in the last 6 months.
                    </ng-template>
                  </div>
                </section>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'explainability')"
                    (click)="toggleRiskDetailSection(row, 'explainability')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'explainability') ? 'expand_more' : 'chevron_right' }}</span>
                    {{ getRiskDetailExplainabilityHeader(row) }}
                  </button>
                  <div class="risk-detail-subsection-body" *ngIf="isRiskDetailSectionExpanded(row, 'explainability')">
                    <p class="risk-detail-subsection-note">Each factor is normalised 0–1 and multiplied by its weight. Sum = explainability score (0–100). This score is for reasoning transparency only — the rank column uses the canonical 4-factor score.</p>
                    <div class="risk-detail-factors-grid">
                      <article class="risk-detail-factor-card" *ngFor="let factor of getRiskDetailExplainabilityFactors(row)">
                        <h6>{{ factor.label }}</h6>
                        <div class="risk-detail-factor-value">{{ factor.value }} · {{ factor.points }}</div>
                        <p>{{ factor.formula }}</p>
                      </article>
                    </div>
                  </div>
                </section>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'aiAdjustedRiskScore')"
                    (click)="toggleRiskDetailSection(row, 'aiAdjustedRiskScore')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'aiAdjustedRiskScore') ? 'expand_more' : 'chevron_right' }}</span>
                    {{ getRiskDetailAiAdjustedHeader(row) }}
                  </button>
                  <div class="risk-detail-subsection-body" *ngIf="isRiskDetailSectionExpanded(row, 'aiAdjustedRiskScore')">
                    <!-- <p class="risk-detail-subsection-note">Semantic correction derived from the source narratives. This score is for monitoring only — the rank column uses the canonical 4-factor score.</p> -->

                    <div class="risk-detail-semantic-block">
                      <h6>Semantic Risk Score</h6>
                      <p>{{ getRiskDetailSemanticRiskScore(row) }}</p>
                    </div>

                    <div class="risk-detail-semantic-block">
                      <h6>Rationale</h6>
                      <p>{{ getRiskDetailSemanticRationale(row) }}</p>
                    </div>

                    <div class="risk-detail-semantic-block">
                      <h6>AI-Adjusted Risk Score Calculation</h6>
                      <ul class="risk-detail-bullet-list" *ngIf="getRiskDetailAiAdjustedCalculationPoints(row).length > 0; else riskDetailAiAdjustedCalculationFallback">
                        <li *ngFor="let point of getRiskDetailAiAdjustedCalculationPoints(row)">{{ point }}</li>
                      </ul>
                      <ng-template #riskDetailAiAdjustedCalculationFallback>
                        <p>No AI-adjusted risk score calculation available for this asset.</p>
                      </ng-template>
                    </div>

                    <div class="risk-detail-semantic-block">
                      <h6>Supporting Evidence</h6>
                      <ul class="risk-detail-bullet-list" *ngIf="getRiskDetailSemanticSupportingEvidence(row).length > 0; else riskDetailSemanticEvidenceFallback">
                        <li *ngFor="let evidence of getRiskDetailSemanticSupportingEvidence(row)">{{ evidence }}</li>
                      </ul>
                      <ng-template #riskDetailSemanticEvidenceFallback>
                        <p>No supporting evidence available for this asset.</p>
                      </ng-template>
                    </div>
                  </div>
                </section>

                <section class="risk-detail-subsection">
                  <button
                    type="button"
                    class="risk-detail-subsection-toggle"
                    [attr.aria-expanded]="isRiskDetailSectionExpanded(row, 'sourceMentions')"
                    (click)="toggleRiskDetailSection(row, 'sourceMentions')">
                    <span class="material-icons-outlined">{{ isRiskDetailSectionExpanded(row, 'sourceMentions') ? 'expand_more' : 'chevron_right' }}</span>
                    {{ getRiskDetailSourceMentionsLabel(row) }}
                  </button>
                  <div class="risk-detail-subsection-body" *ngIf="isRiskDetailSectionExpanded(row, 'sourceMentions')">
                    <div class="risk-detail-subsection-note" *ngIf="isRiskSourceMentionsLoading(row)">Loading source mentions...</div>
                    <div class="risk-detail-subsection-note" *ngIf="hasRiskSourceMentionsLoadError(row)">Unable to load source mentions. Please try again.</div>
                    <div class="risk-detail-sources-table-wrap">
                      <table class="risk-detail-sources-table" aria-label="Source mentions" *ngIf="!isRiskSourceMentionsLoading(row) && !hasRiskSourceMentionsLoadError(row)">
                        <thead>
                          <tr>
                            <th>Source</th>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Previous occurences</th>
                            <th>WO Status</th>
                            <th>Ref</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let sourceRow of getRiskDetailSourceMentionsRows(row)">
                            <td>{{ sourceRow.source }}</td>
                            <td>{{ sourceRow.date }}</td>
                            <td>{{ sourceRow.description }}</td>
                            <td>{{ sourceRow.repetitionTimes }}</td>
                            <td>{{ sourceRow.woStatus }}</td>
                            <td>{{ sourceRow.ref }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
                </ng-container>

                <ng-template #riskDetailLoadingTemplate>
                  <div class="risk-detail-loading">Loading asset detail...</div>
                </ng-template>

                <div class="risk-detail-error" *ngIf="hasRiskDetailLoadError(row)">Unable to load asset detail. Please try again.</div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <ng-template #riskRegisterEmptyState>
      <div class="risk-register-empty-state">{{ riskRegisterEmptyStateMessage }}</div>
    </ng-template>
  </div>

  <div class="risk-register-pagination" *ngIf="isRiskRegisterExpanded && paginatedRiskRegisterRows.length > 0">
    <div class="risk-register-pager-controls">
      <button
        type="button"
        class="pager-btn"
        (click)="goToPreviousRiskRegisterPage()"
        [disabled]="currentRiskRegisterPage === 1"
        aria-label="Previous page">
        <span class="material-icons-outlined pager-icon" aria-hidden="true">chevron_left</span>
      </button>

      <span class="pager-status">Page {{ currentRiskRegisterPage }} of {{ totalRiskRegisterPages }}</span>

      <button
        type="button"
        class="pager-btn"
        (click)="goToNextRiskRegisterPage()"
        [disabled]="currentRiskRegisterPage === totalRiskRegisterPages"
        aria-label="Next page">
        <span class="material-icons-outlined pager-icon" aria-hidden="true">chevron_right</span>
      </button>
    </div>

    <div class="risk-register-page-size">
      <label for="riskRegisterPageSize">Rows per page:</label>
      <select
        id="riskRegisterPageSize"
        class="pager-page-size-select"
        [ngModel]="riskRegisterPageSize"
        (ngModelChange)="onRiskRegisterPageSizeChange($event)"
        aria-label="Rows per page">
        <option *ngFor="let size of riskRegisterPageSizeOptions" [ngValue]="size">{{ size }}</option>
      </select>
    </div>
  </div>

  <div class="filter-dialog-backdrop" *ngIf="isFilterDialogOpen">
    <div
      class="filter-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="filterResultsTitle"
      (click)="$event.stopPropagation()">
      <div class="filter-dialog-header">
        <h3 id="filterResultsTitle">Filter Results</h3>
        <button type="button" class="filter-dialog-close" (click)="closeFilterDialog()" aria-label="Close filter dialog">
          <span class="material-icons-outlined" aria-hidden="true">close</span>
        </button>
      </div>

      <div class="filter-dialog-body">
        <div class="filter-fields-panel">
          <button
            type="button"
            class="filter-field-item"
            *ngFor="let field of filterFields"
            [class.active]="field.key === activeFilterField"
            (click)="setActiveFilterField(field.key)">
            {{ field.label }}
          </button>
        </div>

        <div class="filter-options-panel">
          <div class="filter-options-title">Options</div>

          <label class="filter-option-row">
            <input
              type="checkbox"
              [checked]="isDialogAllSelected(activeFilterField)"
              (change)="onAllDialogFilterToggle(activeFilterField, $any($event.target).checked)" />
            <span>All</span>
          </label>

          <label class="filter-option-row" *ngFor="let option of activeFilterOptions">
            <input
              type="checkbox"
              [checked]="isDialogOptionSelected(activeFilterField, option)"
              (change)="onDialogFilterOptionToggle(activeFilterField, option, $any($event.target).checked)" />
            <span>{{ option }}</span>
          </label>
        </div>
      </div>

      <div class="filter-dialog-footer">
        <button type="button" class="apply-filter-btn" (click)="applyDialogFilters()">Apply</button>
      </div>
    </div>
  </div>

  <div class="risk-edit-dialog-backdrop" *ngIf="isEditDialogOpen" (click)="closeAllDropdowns()">
    <ng-container *ngIf="editDialogRow as row">
      <div
        class="risk-edit-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="riskEditDialogTitle"
        (click)="onEditDialogClick($event)">
        <div class="risk-edit-dialog-header">
          <h3 id="riskEditDialogTitle">Edit Details — {{ row.assetTag }}</h3>
          <button type="button" class="risk-edit-dialog-close" (click)="closeEditDialog()" aria-label="Close edit dialog">
            <span class="material-icons-outlined" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="risk-edit-dialog-body">
          <ng-container *ngIf="!isRiskDetailLoading(row); else riskEditDialogLoadingTemplate">
            <div class="risk-edit-summary-bar">
              <span class="risk-edit-summary-item"><strong>Asset Tag:</strong> {{ getRiskDetailTopSummary(row).assetTag }}</span>
              <span class="risk-edit-summary-item"><strong>Criticality:</strong> {{ getRiskDetailTopSummary(row).criticality }}</span>
              <span class="risk-edit-summary-item"><strong>Score:</strong> {{ getRiskDetailTopSummary(row).score }}</span>
            </div>

            <section class="risk-edit-section">
              <h4>Row Details</h4>
              <div class="risk-edit-fields-grid">
                <div class="risk-edit-field" *ngFor="let column of riskRegisterColumns">
                  <label>{{ column.label }}</label>

                  <ng-container [ngSwitch]="column.key">
                    <div *ngSwitchCase="'riskType'" class="risk-edit-dropdown" [class.open]="riskTypeDropdown.open">
                      <button
                        type="button"
                        class="risk-edit-dropdown-trigger"
                        (click)="toggleRiskTypeDropdown()"
                        aria-haspopup="true"
                        [attr.aria-expanded]="riskTypeDropdown.open">
                        <span>{{ editDialogForm.riskType || 'Select risk type' }}</span>
                        <span class="material-icons-outlined">{{ riskTypeDropdown.open ? 'arrow_drop_up' : 'arrow_drop_down' }}</span>
                      </button>

                      <div class="risk-edit-dropdown-panel" *ngIf="riskTypeDropdown.open">
                        <div class="risk-edit-dropdown-search" *ngIf="getRiskTypeOptions(row).length > 6">
                          <span class="material-icons-outlined search-icon" aria-hidden="true">search</span>
                          <input
                            type="text"
                            [(ngModel)]="riskTypeDropdown.search"
                            name="riskTypeSearch"
                            placeholder="Search risk type"
                            aria-label="Search risk type options" />
                        </div>

                        <ul class="risk-edit-dropdown-options">
                          <li *ngFor="let option of getFilteredDropdownOptions(getRiskTypeOptions(row), riskTypeDropdown.search)">
                            <button
                              type="button"
                              [class.selected]="option === editDialogForm.riskType"
                              (click)="selectRiskType(option)">
                              {{ option }}
                            </button>
                          </li>
                          <li
                            class="risk-edit-dropdown-empty"
                            *ngIf="getFilteredDropdownOptions(getRiskTypeOptions(row), riskTypeDropdown.search).length === 0">
                            No matches found
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div *ngSwitchCase="'failureType'" class="risk-edit-dropdown" [class.open]="failureTypeDropdown.open">
                      <button
                        type="button"
                        class="risk-edit-dropdown-trigger"
                        (click)="toggleFailureTypeDropdown()"
                        aria-haspopup="true"
                        [attr.aria-expanded]="failureTypeDropdown.open">
                        <span>{{ editDialogForm.failureType || 'Select potential failure mode' }}</span>
                        <span class="material-icons-outlined">{{ failureTypeDropdown.open ? 'arrow_drop_up' : 'arrow_drop_down' }}</span>
                      </button>

                      <div class="risk-edit-dropdown-panel" *ngIf="failureTypeDropdown.open">
                        <div class="risk-edit-dropdown-search" *ngIf="getFailureTypeOptions(row).length > 6">
                          <span class="material-icons-outlined search-icon" aria-hidden="true">search</span>
                          <input
                            type="text"
                            [(ngModel)]="failureTypeDropdown.search"
                            name="failureTypeSearch"
                            placeholder="Search failure type"
                            aria-label="Search potential failure mode options" />
                        </div>

                        <ul class="risk-edit-dropdown-options">
                          <li *ngFor="let option of getFilteredDropdownOptions(getFailureTypeOptions(row), failureTypeDropdown.search)">
                            <button
                              type="button"
                              [class.selected]="option === editDialogForm.failureType"
                              (click)="selectFailureType(option)">
                              {{ option }}
                            </button>
                          </li>
                          <li
                            class="risk-edit-dropdown-empty"
                            *ngIf="getFilteredDropdownOptions(getFailureTypeOptions(row), failureTypeDropdown.search).length === 0">
                            No matches found
                          </li>
                        </ul>
                      </div>
                    </div>

                    <span *ngSwitchDefault class="risk-edit-field-value">{{ row[column.key] }}</span>
                  </ng-container>
                </div>
              </div>
            </section>

            <section class="risk-edit-section" *ngIf="getRiskDetailNarrativePoints(row).length > 0">
              <h4>Narrative Summary</h4>
              <ul class="risk-edit-bullet-list">
                <li *ngFor="let point of getRiskDetailNarrativePoints(row)">{{ point }}</li>
              </ul>
            </section>

            <section class="risk-edit-section">
              <h4>Main Concern</h4>
              <textarea
                class="risk-edit-textarea"
                rows="3"
                [(ngModel)]="editDialogForm.mainConcern"
                name="editMainConcern"
                aria-label="Main Concern"></textarea>
            </section>

            <section class="risk-edit-section">
              <h4>Recommended Action</h4>
              <textarea
                class="risk-edit-textarea"
                rows="3"
                [(ngModel)]="editDialogForm.recommendedAction"
                name="editRecommendedAction"
                aria-label="Recommended Action"></textarea>
            </section>

            <section class="risk-edit-section">
              <h4>Comment</h4>
              <textarea
                class="risk-edit-textarea"
                rows="3"
                [(ngModel)]="editDialogForm.comment"
                name="editComment"
                placeholder="Add your comments"
                aria-label="Comment"></textarea>
              <div class="risk-edit-view-actions-wrap">
                <button
                  type="button"
                  class="risk-edit-view-actions-btn"
                  (click)="toggleViewPreviousActions(row)"
                  [disabled]="!canViewPreviousActions(row)"
                  [attr.aria-expanded]="isViewPreviousActionsOpen"
                  [attr.aria-label]="isViewPreviousActionsOpen ? 'Hide previous actions' : 'View previous actions'">
                  {{ isViewPreviousActionsOpen ? 'Hide Previous Actions' : 'View Previous Actions' }}
                </button>
                <span class="risk-edit-view-actions-line" aria-hidden="true"></span>

                <div class="risk-edit-history-filter" *ngIf="isViewPreviousActionsOpen">
                  <button
                    type="button"
                    class="risk-edit-history-filter-btn"
                    (click)="togglePreviousActionsFilterDropdown()"
                    [attr.aria-expanded]="isPreviousActionsFilterOpen"
                    aria-label="Filter previous actions">
                    <span class="material-icons-outlined" aria-hidden="true">filter_alt</span>
                  </button>

                  <div class="risk-edit-history-filter-menu" *ngIf="isPreviousActionsFilterOpen">
                    <label class="risk-edit-history-filter-option" *ngFor="let option of previousActionsFilterOptions">
                      <input
                        type="checkbox"
                        [checked]="isPreviousActionsFilterSelected(option.key)"
                        (change)="onPreviousActionsFilterToggle(option.key)" />
                      <span>{{ option.label }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <section class="risk-edit-history-panel" *ngIf="isViewPreviousActionsOpen">
                <ng-container *ngIf="getModifiedApprovalFieldHistories(row) as modifiedFieldHistories">
                  <ng-container *ngIf="modifiedFieldHistories.length > 0 && hasVisiblePreviousActions(modifiedFieldHistories); else noModifiedHistoryTemplate">
                    <ng-container *ngFor="let fieldHistory of modifiedFieldHistories">
                      <ng-container *ngIf="getFilteredHistoryEntries(fieldHistory.entries) as filteredEntries">
                        <article class="risk-edit-history-card" *ngIf="filteredEntries.length > 0">
                      <ng-container *ngIf="fieldHistory.fieldLabel === 'Delete Action'; else defaultHistoryCardTemplate">
                        <h5 class="risk-edit-history-title">Delete</h5>

                        <div class="risk-edit-delete-history-layout" *ngIf="filteredEntries[0] as deleteEntry">
                          <div class="risk-edit-delete-history-comment-wrap" *ngIf="!shouldHideHistoryComment(deleteEntry)">
                            <span class="risk-edit-delete-history-label">Delete Comment</span>
                            <p class="risk-edit-delete-history-comment">{{ deleteEntry.comment !== '--' ? deleteEntry.comment : 'No comment provided.' }}</p>
                          </div>

                          <div class="risk-edit-delete-history-meta-wrap">
                            <p class="risk-edit-delete-history-meta-row"><span class="risk-edit-delete-history-meta-key">Deleted By:</span> {{ deleteEntry.modifiedBy }}</p>
                            <p class="risk-edit-delete-history-meta-row"><span class="risk-edit-delete-history-meta-key">Deleted At:</span> {{ deleteEntry.modifiedAt }}</p>
                          </div>
                        </div>
                      </ng-container>

                      <ng-template #defaultHistoryCardTemplate>
                        <h5 class="risk-edit-history-title">{{ fieldHistory.fieldLabel }}</h5>

                        <div class="risk-edit-history-values">
                          <div class="risk-edit-history-value-block">
                            <span class="risk-edit-history-label">Initial Value</span>
                            <p class="risk-edit-history-value">{{ fieldHistory.originalValue }}</p>
                          </div>
                          <div class="risk-edit-history-value-block">
                            <span class="risk-edit-history-label">Current Value</span>
                            <p class="risk-edit-history-value">{{ fieldHistory.currentValue }}</p>
                          </div>
                        </div>

                        <div class="risk-edit-history-stage" *ngFor="let entry of filteredEntries">
                          <div class="risk-edit-history-stage-header">
                            <span class="risk-edit-history-stage-badge">Stage {{ getHistoryStageNumber(row, entry) }}</span>
                            <div class="risk-edit-history-stage-meta-block">
                              <span class="risk-edit-history-stage-meta">{{ entry.modifiedAt }}</span>
                              <span class="risk-edit-history-stage-by"><span class="risk-edit-history-stage-by-label">Modified By:</span> {{ entry.modifiedBy }}</span>
                            </div>
                          </div>
                          <p class="risk-edit-history-stage-summary">{{ getHistoryStageSummary(entry) }}</p>
                          <p class="risk-edit-history-stage-comment" *ngIf="entry.comment !== '--' && !shouldHideHistoryComment(entry)">Comment: {{ entry.comment }}</p>
                        </div>
                      </ng-template>
                        </article>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-template #noModifiedHistoryTemplate>
                  <p class="risk-edit-history-empty">No previous actions available.</p>
                </ng-template>
              </section>
            </section>
          </ng-container>

          <ng-template #riskEditDialogLoadingTemplate>
            <div class="risk-edit-dialog-loading">Loading asset detail...</div>
          </ng-template>

          <div class="risk-edit-dialog-error" *ngIf="hasRiskDetailLoadError(row)">Unable to load asset detail. Please try again.</div>
        </div>

        <div class="risk-edit-dialog-footer">
          <button type="button" class="risk-edit-close-btn" (click)="closeEditDialog()">Close</button>
          <button
            type="button"
            class="risk-edit-save-btn"
            (click)="saveEditDialog()"
            [disabled]="isEditDialogSaving">
            {{ isEditDialogSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="risk-delete-dialog-backdrop" *ngIf="isDeleteDialogOpen">
    <ng-container *ngIf="deleteDialogRow as row">
      <div
        class="risk-delete-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="riskDeleteDialogTitle"
        (click)="$event.stopPropagation()">
        <div class="risk-delete-dialog-header">
          <h3 id="riskDeleteDialogTitle">Delete Asset</h3>
          <button type="button" class="risk-delete-dialog-close" (click)="closeDeleteDialog()" aria-label="Close delete dialog">
            <span class="material-icons-outlined" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="risk-delete-dialog-body">
          <p class="risk-delete-dialog-message">
            Are you sure you want to delete this asset: <strong>{{ row.assetTag }}</strong>?
          </p>

          <label class="risk-delete-comment-label" for="riskDeleteComment">Comment (required)</label>
          <textarea
            id="riskDeleteComment"
            class="risk-delete-comment"
            rows="4"
            [(ngModel)]="deleteDialogComment"
            name="riskDeleteComment"
            placeholder="Add a comment"
            required></textarea>
        </div>

        <div class="risk-delete-dialog-footer">
          <button type="button" class="risk-delete-no-btn" (click)="closeDeleteDialog()" [disabled]="isDeleteDialogDeleting">No</button>
          <button type="button" class="risk-delete-yes-btn" (click)="confirmDeleteDialog()" [disabled]="!canConfirmDeleteDialog">
            {{ isDeleteDialogDeleting ? 'Deleting...' : 'Yes' }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="download-confirm-dialog-backdrop" *ngIf="isDownloadConfirmationDialogOpen">
    <div
      class="download-confirm-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="downloadConfirmDialogTitle"
      (click)="$event.stopPropagation()">
      <div class="download-confirm-dialog-header">
        <h3 id="downloadConfirmDialogTitle">Download Report</h3>
        <button type="button" class="download-confirm-dialog-close" (click)="closeDownloadConfirmationDialog()" aria-label="Close download confirmation dialog">
          <span class="material-icons-outlined" aria-hidden="true">close</span>
        </button>
      </div>

      <div class="download-confirm-dialog-body">
        There are a few edits pending. For downloading the latest report with those changes, click on the refresh icon.
      </div>

      <div class="download-confirm-dialog-footer">
        <button
          type="button"
          class="download-confirm-no-btn"
          (click)="onDownloadConfirmationNo()"
          [disabled]="isPdfDownloading">
          No
        </button>
        <button
          type="button"
          class="download-confirm-yes-btn"
          (click)="onDownloadConfirmationYes()"
          [disabled]="isPdfDownloading">
          Ok
        </button>
      </div>
    </div>
  </div>
</section>

<section class="monthly-report-section" *ngIf="isDashboardView">
  <button
    type="button"
    class="monthly-report-toggle"
    (click)="toggleProcessEngineeringMonthlyReport()"
    [attr.aria-expanded]="isProcessEngineeringMonthlyReportExpanded"
    aria-label="Toggle process engineering monthly report">
    <span class="monthly-report-title">{{ processEngineeringMonthlyReportTitle }}</span>
    <span class="material-icons-outlined accordion-icon" [class.expanded]="isProcessEngineeringMonthlyReportExpanded">expand_more</span>
  </button>

  <div class="monthly-report-content" *ngIf="isProcessEngineeringMonthlyReportExpanded">
    <div class="monthly-report-empty-state" *ngIf="!monthlyReport && !isMonthlyReportLoading && !hasMonthlyReportLoadError">
      {{ monthlyReportEmptyStateMessage }}
    </div>

    <div class="monthly-report-empty-state" *ngIf="isMonthlyReportLoading">
      {{ monthlyReportEmptyStateMessage }}
    </div>

    <div class="monthly-report-empty-state" *ngIf="hasMonthlyReportLoadError">
      {{ monthlyReportEmptyStateMessage }}
    </div>

    <ng-container *ngIf="monthlyReport && !isMonthlyReportLoading && !hasMonthlyReportLoadError">
      <h3 class="monthly-report-file-title">{{ monthlyReportDisplayTitle }}</h3>
      <p class="monthly-report-summary">{{ monthlyReportSummary }}</p>

      <h4 class="monthly-report-findings-title" *ngIf="monthlyReportKeyFindings.length > 0">Key Findings</h4>
      <ul class="monthly-report-findings-list" *ngIf="monthlyReportKeyFindings.length > 0">
        <li *ngFor="let finding of monthlyReportKeyFindings">{{ finding }}</li>
      </ul>

      <section class="failure-intelligence-section" *ngIf="monthlyReportIssueRows.length > 0">
      <div class="failure-intelligence-head">
        <h4 class="failure-intelligence-title">Failure &amp; Opportunity Intelligence</h4>
        <p class="failure-intelligence-subtitle">Synthesised from Product Yield/Recovery section + Executive Opportunity</p>
      </div>

      <div class="failure-intelligence-summary-row">
        <span class="failure-summary-chip" [ngClass]="summaryChip.tone" *ngFor="let summaryChip of monthlyIssueSummaryChips">
          {{ summaryChip.count }} {{ summaryChip.label }}
        </span>
      </div>

      <div class="failure-intelligence-table-wrap">
        <table class="monthly-data-table failure-intelligence-table" aria-label="Failure and opportunity intelligence">
          <thead>
            <tr>
              <th>Type</th>
              <th>Asset / Unit</th>
              <th>Issue &amp; Description</th>
              <th>Detail / Root Cause</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let issueRow of monthlyReportIssueRows">
              <td class="issue-type-cell">
                <span class="issue-type-chip" [ngClass]="getMonthlyIssueTypeClass(issueRow.type)">{{ issueRow.type }}</span>
              </td>
              <td>{{ issueRow.assetUnit }}</td>
              <td>{{ issueRow.issueDescription }}</td>
              <td>{{ issueRow.detailRootCause }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </section>

      <section class="equipment-referenced-section" *ngIf="monthlyEquipmentReferencedRows.length > 0">
        <h4 class="equipment-referenced-title">Equipment Referenced</h4>

        <div class="equipment-referenced-table-wrap">
          <table class="monthly-data-table equipment-referenced-table" aria-label="Equipment referenced from monthly report">
            <thead>
              <tr>
                <th>Tag</th>
                <th>Equipment Name</th>
                <th>Context (from report)</th>
                <th>Significance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let equipmentRow of monthlyEquipmentReferencedRows">
                <td>{{ equipmentRow.tag }}</td>
                <td>{{ equipmentRow.equipmentName }}</td>
                <td>{{ equipmentRow.contextFromReport }}</td>
                <td>{{ equipmentRow.significance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="monthly-key-points-section" *ngIf="monthlyItemsRequiringAttention.length > 0 || monthlyOpportunities.length > 0">
        <h4 class="key-points-title attention" *ngIf="monthlyItemsRequiringAttention.length > 0">Items Requiring Attention</h4>
        <ul class="key-points-list attention" *ngIf="monthlyItemsRequiringAttention.length > 0">
          <li *ngFor="let item of monthlyItemsRequiringAttention">{{ item }}</li>
        </ul>

        <h4 class="key-points-title opportunities" *ngIf="monthlyOpportunities.length > 0">Opportunities</h4>
        <ul class="key-points-list opportunities" *ngIf="monthlyOpportunities.length > 0">
          <li *ngFor="let item of monthlyOpportunities">{{ item }}</li>
        </ul>
      </section>
    </ng-container>
  </div>
</section>
